// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__9VszF","tab":"ProcedureTabs_tab__29WsS"};